// ============================================================================
// RUSSIAN TRANSLATIONS - CHAPTER 7: ПОСЛАНИЯ И ОТКРОВЕНИЕ
// ============================================================================
// Уровни 79-91 (13 уровней, 39 вопросов)

export const chapter7Translations = {
  name: "Послания и Откровение",
  description: "Побеждающий наследует всё... Мудрость свыше освящает разумение",
  
  spiritualWisdom: {
    principle: "Мудрость свыше освящает разумение и оживляет дух",
    scripture: "Если же у кого из вас недостает мудрости, да просит у Бога (Иакова 1:5)",
    application: "Каждое апостольское послание и каждое видение Откровения обогащает наше понимание и укрепляет нашу надежду"
  },
  
  levels: {
    79: {
      name: "Арест в Иерусалиме",
      challenge: "Я готов не только быть узником, но и умереть в Иерусалиме...",
      easy: {
        question: "Где был арестован Павел во время последнего визита?",
        options: ["Антиохия", "Эфес", "Иерусалим", "Коринф"],
        correctAnswer: 2,
        hint: "Святой город, часто преследовавший пророков",
        funFact: "🏛️ Иерусалим: место славы и страданий для всех слуг Божьих!"
      },
      medium: {
        question: "В чём иудеи обвинили Павла?",
        options: [
          "В краже из Храма",
          "В осквернении Храма введением язычников",
          "В богохульстве против Моисея",
          "В мятеже против Рима"
        ],
        correctAnswer: 1,
        hint: "Обвинение, связанное с универсальностью Евангелия",
        funFact: "⛪ Ирония: Павла обвинили в осквернении Храма, который он глубоко чтил!"
      },
      hard: {
        question: "Как Павел превратил своё заключение в возможность?",
        options: [
          "Сбежал",
          "Свидетельствовал перед властями и писал послания",
          "Молчал",
          "Договорился об освобождении"
        ],
        correctAnswer: 1,
        hint: "Речь о превращении испытания в свидетельство",
        funFact: "⛓️ Физические цепи, духовная свобода - мощное свидетельство веры!"
      }
    },
    
    80: {
      name: "Перед Правителем Феликсом",
      challenge: "Когда он рассуждал о правде, воздержании и будущем суде...",
      easy: {
        question: "Перед каким правителем Павел свидетельствовал о своей вере?",
        options: ["Пилат", "Феликс", "Фест", "Галлион"],
        correctAnswer: 1,
        hint: "Правитель, известный своей алчностью",
        funFact: "⚖️ Феликс надеялся на взятку - коррупция перед лицом честности!"
      },
      medium: {
        question: "Какова была реакция Феликса на послание Павла?",
        options: [
          "Обратился",
          "Устрашился и затрепетал",
          "Насмехался",
          "Остался равнодушным"
        ],
        correctAnswer: 1,
        hint: "Совесть, встревоженная истиной",
        funFact: "😰 Даже коррумпированные трепещут перед Божьей истиной - универсальная совесть!"
      },
      hard: {
        question: "Почему Феликс держал Павла в заключении два года?",
        options: [
          "Чтобы защитить его",
          "Из-за политических интересов и надежды на коррупцию",
          "Забыл",
          "Из убеждения"
        ],
        correctAnswer: 1,
        hint: "Речь о политических и личных расчётах",
        funFact: "🏛️ Коррумпированное человеческое правосудие vs совершенное Божье - резкий контраст!"
      }
    },

    81: {
      name: "Апелляция к Кесарю",
      challenge: "Я требую суда кесарева!",
      easy: {
        question: "Какое право использовал Павел, чтобы избежать суда в Иерусалиме?",
        options: [
          "Право убежища",
          "Апелляция к кесарю (римский гражданин)",
          "Право бегства",
          "Дипломатическая защита"
        ],
        correctAnswer: 1,
        hint: "Привилегия его римского гражданства",
        funFact: "🏛️ Римское гражданство: Божий паспорт для доставки Евангелия в Рим!"
      },
      medium: {
        question: "Перед кем Павел свидетельствовал перед отправлением?",
        options: [
          "Синедрионом",
          "Царём Агриппой и Вереникой",
          "Римскими солдатами",
          "Иудейской толпой"
        ],
        correctAnswer: 1,
        hint: "Иудаизированная царская семья Ирода",
        funFact: "👑 От пастуха овец до царского дворца - Божье возвышение Павла!"
      },
      hard: {
        question: "Как Бог использует человеческие системы для Своих планов?",
        options: [
          "Игнорирует их",
          "Использует промыслительно для осуществления Своих замыслов",
          "Разрушает их",
          "Всегда противостоит им"
        ],
        correctAnswer: 1,
        hint: "Речь о Божьем суверенитете над историей",
        funFact: "🌐 Римское правосудие становится проводником Евангелия - замечательное провидение!"
      }
    },

    82: {
      name: "Кораблекрушение на Мальте",
      challenge: "Не бойся, Павел; ты должен предстать пред кесаря...",
      easy: {
        question: "На каком острове Павел потерпел кораблекрушение?",
        options: ["Крит", "Кипр", "Мальта", "Сицилия"],
        correctAnswer: 2,
        hint: "Маленький остров к югу от Сицилии",
        funFact: "🏝️ Мальта: вынужденная остановка становится плодотворной миссией - Божьи обходные пути!"
      },
      medium: {
        question: "Какое чудо совершил Павел на Мальте?",
        options: [
          "Успокоил бурю",
          "Исцелил отца Публия и других больных",
          "Умножил пищу",
          "Воскресил мёртвого"
        ],
        correctAnswer: 1,
        hint: "Множественные исцеления на острове",
        funFact: "🏥 Павел: от потерпевшего кораблекрушение до чудотворного врача - Божья репутация!"
      },
      hard: {
        question: "Как это кораблекрушение иллюстрирует Божью верность?",
        options: [
          "Несчастные случаи происходят",
          "Бог защищает и исполняет Свои обещания несмотря на препятствия",
          "Павлу повезло",
          "Это можно было избежать"
        ],
        correctAnswer: 1,
        hint: "Речь о Божьей верности обещаниям",
        funFact: "⛈️ Буря, кораблекрушение, змея: ничто не остановит Божий план для Павла!"
      }
    },

    83: {
      name: "Павел в Риме",
      challenge: "Целых два года он оставался в нанятом им помещении...",
      easy: {
        question: "В каких условиях Павел жил в Риме?",
        options: [
          "В закрытой тюрьме",
          "Под домашним арестом",
          "В полной свободе",
          "В изгнании"
        ],
        correctAnswer: 1,
        hint: "Относительная свобода под надзором",
        funFact: "🏠 Дом-тюрьма становится миссионерским центром - свобода в цепях!"
      },
      medium: {
        question: "Что делал Павел в течение двух лет в Риме?",
        options: [
          "Отдыхал",
          "Учил и писал послания",
          "Готовил свою защиту",
          "Занимался туризмом"
        ],
        correctAnswer: 1,
        hint: "Интенсивное служение несмотря на цепи",
        funFact: "✍️ Послания из тюрьмы: Ефесянам, Филиппийцам, Колоссянам, Филимону!"
      },
      hard: {
        question: "Как Павел завершил своё служение согласно традиции?",
        options: [
          "Умер от болезни",
          "Был обезглавлен при Нероне около 67 г. н.э.",
          "Умер от старости",
          "Таинственно исчез"
        ],
        correctAnswer: 1,
        hint: "Мученичество при безумном императоре",
        funFact: "⚔️ 'Подвигом добрым я подвизался, течение совершил' - окончательная победа!"
      }
    },

    84: {
      name: "Послание к Римлянам",
      challenge: "Я не стыжусь благовествования; оно есть сила Божия ко спасению...",
      easy: {
        question: "Какое послание наиболее развивает учение о спасении верой?",
        options: ["1 Коринфянам", "Галатам", "Римлянам", "Ефесянам"],
        correctAnswer: 2,
        hint: "Богословский 'собор' Павла",
        funFact: "🏛️ Римлянам: богословский шедевр, обративший Августина и Лютера!"
      },
      medium: {
        question: "Согласно Римлянам, как человек оправдывается перед Богом?",
        options: [
          "Добрыми делами",
          "Одной верой, без дел",
          "Жертвоприношениями",
          "Традицией"
        ],
        correctAnswer: 1,
        hint: "Фундаментальный принцип Реформации",
        funFact: "⚖️ 'Праведный верою жив будет' - духовная революция Павла!"
      },
      hard: {
        question: "Каков универсальный охват этого послания?",
        options: [
          "Касается только римлян",
          "Излагает план спасения для всего человечества",
          "Критикует только Рим",
          "Устарело"
        ],
        correctAnswer: 1,
        hint: "Речь об универсальном плане спасения",
        funFact: "🌍 Евангелие = сила Божья для всех: иудеев и эллинов - полная универсальность!"
      }
    },

    85: {
      name: "Гимн Любви - 1 Коринфянам 13",
      challenge: "Если я говорю языками человеческими и ангельскими, а любви не имею...",
      easy: {
        question: "Какая глава Библии называется 'гимном любви'?",
        options: [
          "1 Коринфянам 12",
          "1 Коринфянам 13",
          "1 Иоанна 4",
          "Римлянам 8"
        ],
        correctAnswer: 1,
        hint: "Центральная глава 1 Коринфянам",
        funFact: "💝 Глава, чаще всего читаемая на свадьбах - совершенное определение любви!"
      },
      medium: {
        question: "Что Павел говорит о длительности любви?",
        options: [
          "Любовь проходит со временем",
          "Любовь никогда не перестает",
          "Любовь зависит от обстоятельств",
          "Любовь временна"
        ],
        correctAnswer: 1,
        hint: "Вечность Божьей любви",
        funFact: "♾️ Только любовь пересекает смерть и вечность - высшая ценность!"
      },
      hard: {
        question: "Почему Павел ставит любовь выше духовных даров?",
        options: [
          "Дары плохи",
          "Любовь придаёт смысл и ценность всему остальному",
          "Любовь легче",
          "Дары разделяют"
        ],
        correctAnswer: 1,
        hint: "Речь о двигателе и смысле всякого служения",
        funFact: "🎯 Без любви даже величайшие дары становятся шумом и гордостью!"
      }
    },

    86: {
      name: "Ефесянам: Церковь - Тело Христово",
      challenge: "Всё покорил под ноги Его и поставил Его выше всего, главою Церкви...",
      easy: {
        question: "Согласно Ефесянам, что есть Церковь в отношении ко Христу?",
        options: [
          "Его храм",
          "Его тело",
          "Его семья",
          "Его армия"
        ],
        correctAnswer: 1,
        hint: "Органическая метафора единства",
        funFact: "👤 Тело Христово: каждый христианин - жизненно важный член - взаимозависимость!"
      },
      medium: {
        question: "Какие доспехи описывает Павел для духовной борьбы?",
        options: [
          "Физические доспехи",
          "Доспехи Божии: истина, праведность, мир, вера, спасение, Слово",
          "Римские доспехи",
          "Магическая защита"
        ],
        correctAnswer: 1,
        hint: "Шесть элементов духовных доспехов",
        funFact: "⚔️ Духовная борьба духовным оружием - Божья стратегия победы!"
      },
      hard: {
        question: "Против кого наша истинная борьба согласно Павлу?",
        options: [
          "Против злых людей",
          "Против духовных сил зла",
          "Против правительств",
          "Против бедности"
        ],
        correctAnswer: 1,
        hint: "Речь о невидимых духовных силах",
        funFact: "👹 Космическая борьба: за человеческими конфликтами - реальная духовная война!"
      }
    },

    87: {
      name: "Филиппийцам: Радость в Испытании",
      challenge: "Радуйтесь всегда в Господе; и ещё говорю: радуйтесь!",
      easy: {
        question: "Какое чувство Павел поощряет несмотря на своё заключение?",
        options: ["Смирение", "Радость", "Гнев", "Печаль"],
        correctAnswer: 1,
        hint: "Удивительная эмоция для узника",
        funFact: "😊 Радость 16 раз в 4 главах - рекорд счастья в тюрьме!"
      },
      medium: {
        question: "Согласно Филиппийцам 2, какую позицию принял Иисус?",
        options: [
          "Навязал силой",
          "Уничижил Себя и смирился до смерти",
          "Бежал от ответственности",
          "Искал славы"
        ],
        correctAnswer: 1,
        hint: "Добровольное нисходящее движение",
        funFact: "📉 Иисус: от равенства с Богом до смерти на кресте - крайняя любовь!"
      },
      hard: {
        question: "Как Павел может проповедовать радость в тюрьме?",
        options: [
          "Притворяется",
          "Христианская радость превосходит обстоятельства",
          "Мазохист",
          "Отрицает реальность"
        ],
        correctAnswer: 1,
        hint: "Речь о сверхъестественной радости",
        funFact: "✨ Радость = плод Духа независимо от обстоятельств - Божья тайна!"
      }
    },

    88: {
      name: "Пастырские Послания",
      challenge: "Подвизайся добрым подвигом веры, держись вечной жизни...",
      easy: {
        question: "Кому Павел написал свои последние пастырские послания?",
        options: [
          "Коринфянам",
          "Тимофею и Титу",
          "Римлянам",
          "Галатам"
        ],
        correctAnswer: 1,
        hint: "Его духовные сыновья и сотрудники",
        funFact: "👨‍👦 Духовное завещание: Павел передаёт факел следующему поколению!"
      },
      medium: {
        question: "Какой совет Павел даёт по выбору церковных лидеров?",
        options: [
          "Выбирать самых богатых",
          "Выбирать по строгим моральным и духовным критериям",
          "Выбирать самых образованных",
          "Выбирать самых популярных"
        ],
        correctAnswer: 1,
        hint: "Моральные качества прежде всего",
        funFact: "⚖️ Высокие стандарты для лидеров: характер прежде компетентности - Божьи приоритеты!"
      },
      hard: {
        question: "Какое наследие Павел оставляет Тимофею?",
        options: [
          "Материальные блага",
          "Верность Евангелию и пастырское служение",
          "Политическую должность",
          "Богословскую школу"
        ],
        correctAnswer: 1,
        hint: "Речь о духовном наследии",
        funFact: "📜 'Храни добрый залог' - верная передача Евангелия через века!"
      }
    },

    89: {
      name: "Евреям: Иисус Первосвященник",
      challenge: "Имеем великого Первосвященника, прошедшего небеса...",
      easy: {
        question: "Согласно Евреям, кто наш великий Первосвященник?",
        options: ["Аарон", "Моисей", "Иисус", "Мелхиседек"],
        correctAnswer: 2,
        hint: "Совершенный посредник между Богом и людьми",
        funFact: "✝️ Иисус: Священник и Жертва - совершенная жертва раз и навсегда!"
      },
      medium: {
        question: "Почему священство Иисуса выше священства Аарона?",
        options: [
          "Древнее",
          "Вечное по чину Мелхиседека",
          "Богаче",
          "Популярнее"
        ],
        correctAnswer: 1,
        hint: "Вечность vs временность",
        funFact: "♾️ Вечное священство: Иисус вечно ходатайствует за нас!"
      },
      hard: {
        question: "Как Евреям представляет Новый Завет?",
        options: [
          "Идентичным старому",
          "Превосходным и окончательным, написанным в сердцах",
          "Временным",
          "Необязательным"
        ],
        correctAnswer: 1,
        hint: "Речь об исполнении и превосходстве",
        funFact: "📋 Новый Завет: закон, написанный в сердцах, а не на камне!"
      }
    },

    90: {
      name: "Иакова: Вера и Дела",
      challenge: "Вера без дел мертва...",
      easy: {
        question: "Согласно Иакову, что должно сопровождать веру?",
        options: [
          "Слова",
          "Дела",
          "Эмоции",
          "Знание"
        ],
        correctAnswer: 1,
        hint: "Практическое проявление веры",
        funFact: "🌳 Вера = корень, дела = плоды - полное духовное дерево!"
      },
      medium: {
        question: "С чем Иаков сравнивает язык?",
        options: [
          "С мечом",
          "С малым огнём, воспламеняющим большой лес",
          "С музыкальным инструментом",
          "С инструментом"
        ],
        correctAnswer: 1,
        hint: "Маленький член, но великая разрушительная сила",
        funFact: "🔥 Язык: маленький член, но может поджечь всю жизнь - осторожность!"
      },
      hard: {
        question: "Как примирить Иакова и Павла в вопросе вера/дела?",
        options: [
          "Они противоречат",
          "Павел говорит об оправдании, Иаков о освящении",
          "Один ошибается",
          "Нет решения"
        ],
        correctAnswer: 1,
        hint: "Речь о двух дополняющих аспектах",
        funFact: "⚖️ Павел: спасение верой / Иаков: вера, доказанная делами - совершенная гармония!"
      }
    },

    91: {
      name: "Откровение: Возвращение Царя",
      challenge: "Се, гряду скоро. Блажен соблюдающий слова пророчества книги сей!",
      easy: {
        question: "Скольким церквам Иоанн пишет в Откровении?",
        options: ["5", "7", "10", "12"],
        correctAnswer: 1,
        hint: "Число совершенства",
        funFact: "⛪ 7 церквей Азии: зеркало всех церквей всех времён!"
      },
      medium: {
        question: "Как заканчивается история согласно Откровению?",
        options: [
          "Полное уничтожение",
          "Новое небо и новая земля",
          "Возвращение в земной рай",
          "Конец всякого существования"
        ],
        correctAnswer: 1,
        hint: "Полное обновление творения",
        funFact: "🌅 Не конец мира, а полное обновление - окончательная надежда!"
      },
      hard: {
        question: "Какое центральное послание Откровение передаёт гонимым?",
        options: [
          "Сдавайтесь",
          "Христос царствует и окончательно победит",
          "Бегите от гонений",
          "Мстите"
        ],
        correctAnswer: 1,
        hint: "Речь о надежде на окончательную победу",
        funFact: "👑 'Который был, есть и грядёт' - Господь истории и времени!"
      }
    }
  }
};

export default chapter7Translations;
